import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CommonService } from '../../services/common.service';
import { SharedComponent } from '../../shared/shared';
import {FormGroup,FormControl,FormBuilder } from "@angular/forms";

/**
 * Generated class for the QrcodePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 @IonicPage()
 @Component({
 	selector: 'page-qrcode',
 	templateUrl: 'qrcode.html',
 })
 export class QrcodePage {

   @ViewChild('qrcodespan') newscont: ElementRef;

   companyName = '';


 	qrcodeForm = new FormGroup({
 		subject: new FormControl(),
 		description: new FormControl()
 	});

   svg = `<svg height="100" width="100" xmlns="http://www.w3.org/2000/svg">
  <circle r="45" cx="50" cy="50" fill="red" />
</svg>`;

 	constructor(public navCtrl: NavController, public navParams: NavParams, public commonService :CommonService ,public sharedClass:SharedComponent,public fb : FormBuilder ) {
 	}

 	ionViewDidLoad() {
 		console.log('ionViewDidLoad QrcodePage');
 	}

 	ngOnInit() {

 		// this.qrcodeForm = this.fb.group({
 		// 	subject: ['', Validators.compose([Validators.required, Validators.minLength(2)])],
 		// 	description: ['', Validators.compose([Validators.required,Validators.minLength(60) ])]
 		// });  
     const company =  this.commonService.getLoggedInUserData().company.vendorCode;
     this.companyName = this.commonService.getLoggedInUserData().company.companyName;
     this.getMyQRCode(company);
     //this.newscont.nativeElement.innerHTML= this.svg;

 	}


 	public getMyQRCode(vendoreCode) {

 		this.commonService.showLoading();

 		//formValues.userId=(this.commonService.getLoggedInUserData())?this.commonService.getLoggedInUserData().userId:'';


     const body = new FormData();
     body.append('section', '#link');
     body.append('link', `https://customerfeedrate.com/login/#/rating?vendorCode=${vendoreCode}`);

  //{section:'#link', link:`https://customerfeedrate.com/login/#/rating?vendorCode=${vendoreCode}`}
 		this.commonService.getMyQRCode(body).subscribe(success => {

 			this.commonService.dismisshowoading();
 			if (success && success.content) {

         this.newscont.nativeElement.innerHTML= success.content;

 				// var loginUserData=this.commonService.getLoggedInUserData();
 				// loginUserData.fullName=formValues.firstName+" "+formValues.lastName;
 				// loginUserData.email=formValues.email;
 				// loginUserData.phoneNumber=formValues.phoneNumber;
 				// this.commonService.setLoggedInUserData(loginUserData);


 				//this.commonService.showPopup("Success", "Your query sent successfully. You will get response to this query on your email.");


 			} else {
//          this.svg = `<svg height="100" width="100" xmlns="http://www.w3.org/2000/svg">
//   <circle r="45" cx="50" cy="50" fill="red" />
// </svg>`;



 				this.commonService.showPopup("Sorry", this.sharedClass.messages.ServerError);
 			}
 		});  
          /*,
        error => {
          this.commonService.dismisshowoading();
          console.log("ssssssssssss error",error);
          this.showPopup("Error server", error);
      });*/
  }

   public printPage(): void {
    window.print()
  }

}



// WEBPACK FOOTER //
// ./src/pages/qrcode/qrcode.ts